import { render, staticRenderFns } from "./ObjectLocator.vue?vue&type=template&id=72658fed&scoped=true&"
import script from "./ObjectLocator.vue?vue&type=script&lang=ts&"
export * from "./ObjectLocator.vue?vue&type=script&lang=ts&"
import style0 from "./ObjectLocator.vue?vue&type=style&index=0&id=72658fed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72658fed",
  null
  
)

export default component.exports